// TODO create entities for this
export const GRUPOS_DE_INTERES = [
  'Estudiantes',
  'Docentes',
  'Egresados',
  'Administrativos y directivos',
  'Sector productivo',
];

export const RUTAS = {
  LOGIN: '/',
  CARGUE_DOCUMENTOS: '/cargue-documentos',
  INICIO: '/inicio',
  PRUEBA: '/prueba',
  DIMENSION: '/dimension',
  FACTOR: '/factor',
  CARACTERISTICAS: '/caracteristicas',
  CARACTERISTICA_GRUPO_INTERES: '/caracteristica-grupo-interes',
  INDICADOR: '/indicador',
  EVIDENCIA_CUMPLIMIENTO: '/evidencia-cumplimiento',
  ESCUELA: '/escuela',
  PROGRAMAS_ACADEMICOS: '/programas-academicos',
  ENCUESTAS: '/encuestas',
  DETALLE_ENCUESTA: '/encuestas/:id',
  VISTA_PREVIA_ENCUESTA: '/encuestas/:id/vista-previa',
  PREGUNTAS: '/preguntas',
}
